export default __webpack_public_path__ + "static/transportation-accomplishment-1e-34ddc7736d32cdd1418ab2d27d8eee2f.webp";